import { Component, OnDestroy } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { MonitoredHttpState, JWT_STATUS } from '@c4/core';


@Component({
  selector: 'cw-composer',
  templateUrl: './composer.component.html'
})
export class ComposerComponent implements OnDestroy {

  private _subs: Subscription[] = [];

  constructor(
    private _store: Store<{
      monitoredHttpState: MonitoredHttpState
    }>,
    private _router: Router
  ) {
    const jwtStatus = this._store.select(s => s.monitoredHttpState.jwtStatus);

    this._subs.push(

      // If at any point we lose our JWT, back to login...
      jwtStatus.filter(s => s == JWT_STATUS.INVALID || s == JWT_STATUS.NONE)
        .subscribe(s => {
          this._router.navigate(['/authenticate']);
        })

    );


  }

  ngOnDestroy() {
    this._subs.forEach(sub => {
      sub.unsubscribe();
    });
  }

}




// WEBPACK FOOTER //
// ./src/app/composer/composer.component.ts